// extracted by mini-css-extract-plugin
module.exports = {"codeContainer":"WhatsappWidgetStep3_codeContainer__293p5","codeBlock":"WhatsappWidgetStep3_codeBlock__OVAsg"};